export function fullName(user) {
  return [user?.last_name, user?.first_name].filter(Boolean).join(" ");
}

export function formatDateTime(value) {
  if (!value) return "—";
  return new Date(value).toLocaleString("ru-RU", { dateStyle: "short", timeStyle: "short" });
}
